// Autogenerated file
export const userMessageFlagsEnum = {
    None: "None",
    Mentioned: "Mentioned",
};
export const userMessageFlags = [
    { label: "Без параметров", value: "None", intValue: 0 },
    { label: "Было упоминание", value: "Mentioned", intValue: 1 },
];
